import{a as r}from"./ninox-components-ZXBPGGT2.js";import{a as c}from"./ninox-components-4KWCCUJ4.js";import{l as n}from"./ninox-components-GQTCIGTF.js";import{m as e}from"./ninox-components-2ADN25D5.js";import{f as l}from"./ninox-components-DFJEWGV6.js";import{f as t}from"./ninox-components-MYF6AQNE.js";import{k as d}from"./ninox-components-R4FVH3NU.js";import{a as s}from"./ninox-components-I2GBTDK4.js";import{c as a}from"./ninox-components-YAP3BY3K.js";import i from"styled-components";var u=i.div`
    flex: 1 1 0px;
    position: relative;
    display: inline-flex;
    align-items: center;
    flex-flow: row nowrap;
    overflow: hidden;
    height: 100%;
    margin-right: auto;
    isolation: isolate;
`,m=i.div`
    min-width: 0;
    max-width: 100%;

    visibility: ${({visible:o})=>o?"visible":"hidden"};
    pointer-events: none;
    user-select: none;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    ${({theme:o})=>o.combobox.placeholder};
`,w=i(r)`
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    box-sizing: border-box;
    min-width: 0;
    max-width: 100%;

    visibility: ${({visible:o})=>o?"visible":"hidden"};
    user-select: text;
    white-space: nowrap;
    outline: none;

    overflow-x: overlay;
    overflow-y: hidden;

    & > * {
        margin: ${e.tiny};
    }
    & > :first-child {
        margin-left: 0;
    }
`,b=i.div`
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    user-select: none;

    ${({theme:o})=>o.combobox.icon.default}
`,g=i.input`
    position: absolute;
    top: 50%;
    left: 0;

    width: ${e.xxx_small};
    max-width: 100%;
    margin: 0;
    padding: 0;
    transform: translateY(-50%);

    line-height: 1;
    font-weight: inherit;
    font-size: inherit;
    font-family: inherit;

    outline: none;
    border-width: 0;
    color: inherit !important;
    background-color: transparent !important;

    &:focus {
        width: fit-content;
    }
`,$=i.input`
    position: absolute;
    inset: 0;
    z-index: -1;
    opacity: 0;
    pointer-events: none;
`,v=i(c)`
    color: inherit;
    margin-right: -${e.xx_small};

    :focus,
    :hover {
        color: ${({theme:o})=>o.icon.attention};
    }
`,y=i.div`
    box-sizing: border-box;
    width: 100%;
    padding: ${e.x_small} ${e.medium};

    ${({theme:o})=>o.combobox.placeholder};

    text-align: center;
    font-style: italic;
`,z=i.div`
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: stretch;
    flex-shrink: 0;
    position: relative;
    box-sizing: border-box;

    height: calc(${n.m} + 2 * ${t.tiny});
    min-width: calc(4 * ${n.m});
    width: fit-content;
    padding-left: ${e.x_small};
    padding-right: ${e.small};

    outline: none;
    border-radius: ${l.medium};
    border-width: ${t.tiny};
    border-style: solid;

    font-family: ${a.sans};
    font-size: ${d.medium};
    font-weight: ${s.normal};

    transition-timing-function: ease;
    transition-duration: 150ms;
    transition-property: color, background-color, border-color;

    cursor: pointer;

    ${({theme:o})=>o.combobox.default};

    &:hover {
        ${({theme:o})=>o.combobox.hover}
    }

    &:focus-within,
    &[aria-expanded='true'] {
        ${({theme:o})=>o.combobox.focus}
    }

    &[aria-invalid='true'] {
        ${({theme:o})=>o.combobox.invalid}
    }

    &[aria-disabled='true'] {
        cursor: default;
        ${({theme:o})=>o.combobox.disabled}
    }

    &[aria-disabled='true'],
    &[aria-disabled='true'] ${m} {
        color: ${({theme:o})=>o.combobox.disabled.color};
    }

    &[aria-disabled='true'] ${b} {
        ${({theme:o})=>o.combobox.icon.disabled}
    }
`,S=i(r)`
    border-radius: inherit;
`;export{u as a,m as b,w as c,b as d,g as e,$ as f,v as g,y as h,z as i,S as j};
//# sourceMappingURL=ninox-components-P2LOMKLL.js.map